module.exports = "fragment OnlyIdsContactFragment on Contact {\n  __typename\n  id\n}\n"